<dropdown-panel
  title="Lighting"
  [collapsedContent]="lightTogglers"
  [hideHeader]="!!controlledDevice"
  [initiallyExpanded]="true"
>
  <div class="expanded_toggle" *ngIf="!controlledDevice">
    <div
      class="switch-all_button"
      (click)="switchAllDevices()"
      [ngClass]="{ 'switch-all_button_disabled': !allEnabled }"
    >
      <ion-icon name="power"></ion-icon>
      <span>All lights</span>
    </div>

    <div class="buttons_layout">
      <ng-container *ngFor="let device of lightDevices">
        <div class="control-block">
          <div
            class="button shadow"
            [class]="device.active ? 'enabled' : 'disabled'"
            (click)="switchCurrentLightDevice(device.deviceId)"
          >
            <span class="button-title">{{device.title}}</span>
            <ion-icon
              *ngIf="device.active"
              src="assets/lightbulb_btn_on.svg"
              size="large"
              class="button-icon"
            ></ion-icon>
            <ion-icon
              *ngIf="!device.active"
              src="assets/lightbulb_btn_off.svg"
              size="large"
              class="button-icon"
            ></ion-icon>
          </div>

          <div class="button">
            <ion-icon
              *ngIf="device.active"
              src="assets/light_colorpicker_on.svg"
              size="large"
              class="button-icon shadow"
              (click)="showSettingsPanel(device)"
            ></ion-icon>
            <ion-icon
              *ngIf="!device.active"
              src="assets/light_colorpicker_off.svg"
              size="large"
              class="button-icon shadow"
              (click)="showSettingsPanel(device)"
            ></ion-icon>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <light-settings
    *ngIf="controlledDevice"
    [lightDevice]="controlledDevice"
    [colorPresets]="colorPresets"
    [selectedPresetByDevice]="selectedPresetByDevice"
    (onClose)="hideSettingsPanel()"
  ></light-settings>
</dropdown-panel>

<ng-template #lightTogglers>
  <div class="collapsed_toggle buttons_layout">
    <ng-container *ngFor="let device of lightDevices">
      <div class="button">
        <ion-icon
          *ngIf="device.active"
          src="assets/lightbulb_btn_on.svg"
          size="large"
          class="button-icon enabled"
        ></ion-icon>
        <ion-icon
          *ngIf="!device.active"
          src="assets/lightbulb_btn_off.svg"
          size="large"
          class="button-icon disabled"
        ></ion-icon>
        <span class="button-title">{{device.title}}</span>
      </div>
    </ng-container>
  </div>
</ng-template>
